import { trackErrorMessageDisplayed } from 'client/javascript/analytics';

/**
 * Create Account Error Tracking
 * @param error
 * @param errorMessage
 * @param setIsExistingUser
 * @param pageType
 */
export function trackNewAccountError(error, errorMessage, setIsExistingUser, pageType, email) {
  const props = {
    track_label: 'Error Message Create Account',
    error_type: error,
    error_message: errorMessage,
    error_existing_user: setIsExistingUser,
    page_type: pageType,
    user_email: email
  };
  trackErrorMessageDisplayed(props);
}

/**
 * Common Error Tracking for logger.error cases
 * @param error
 * @param errorMessage
 * @param pageType
 */
export function trackError(error, errorMessage, pageType) {
  const props = {
    track_label: 'Error Message ',
    error_type: error,
    error_message: errorMessage,
    page_type: pageType
  };
  trackErrorMessageDisplayed(props);
}
